import type { IBulkEditTagsConnectionSnapshot } from '../../../../services/actions/app/useAppHandlers'

const NOT_SYNCED_TAGS_TOAST =
    'Tags are available only for synced LinkedIn 1st contacts. Add this person to LeadDelta first.'

type SetBulkEditTagsModal = (
    selectedConnectionsIds?: string[],
    selectedAllConnections?: boolean,
    connectionTagSnapshots?: IBulkEditTagsConnectionSnapshot[],
    options?: { closeOnBackdropClick?: boolean }
) => void

type ShowToast = (payload: { message: string }) => void

/** Open Edit Tags from Inbox; toast when the conversation is not linked to a synced connection. */
export const openInboxBulkTags = (
    connectionId: string | undefined | null,
    tags: any[] | undefined,
    setBulkEditTagsModal: SetBulkEditTagsModal,
    showInfoToast: ShowToast
) => {
    if (!connectionId) {
        showInfoToast({ message: NOT_SYNCED_TAGS_TOAST })
        return
    }
    const sid = String(connectionId)
    const snapshotTags = Array.isArray(tags) ? tags : []
    setBulkEditTagsModal(
        [sid],
        false,
        [{ connectionId: sid, tags: snapshotTags }],
        { closeOnBackdropClick: true }
    )
}

export const INBOX_TAGS_NOT_SYNCED_MESSAGE = NOT_SYNCED_TAGS_TOAST
